import axios from 'axios';
import { gateway, portal, apikey, checkout, } from '../config';

export async function getProducts() {
  const { data } = await axios.get(`${gateway}/api/${portal.path}/user/products`, {
    headers: {
      apikey,
    }
  });
  return data.results;
}

export async function getPromocodes() {
  const { data } = await axios.get(`${gateway}/api/${portal.path}/user/promocode?filter[limit]=1000&filter[where][usage_limits][neq]=0`, {
    headers: {
      apikey,
    }
  });
  return data.results;
}

export async function getMerchants() {
  return await axios.get(`${gateway}/api/${portal.path}/user/merchants`, {
    headers: {
      apikey,
    }
  });
}

export async function getStripeToken(publicKey, url, card) {
  let payload = {};
  const config = {
    headers: {},
  };
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  payload = encodeURI(`card[name]=${card.name}&card[card_type]=${card.cardType}&card[number]=${card.cardNumber}&card[exp_month]=${card.expMonth}&card[exp_year]=${card.expYear}&card[cvc]=${card.cardCvv}`);
  config.headers.Authorization = `Bearer ${publicKey}`;
  return await axios.post(url, payload, config);
}

export async function postPayment(payload) {
  return await axios.post(checkout, payload);
}

export async function toOauth() {
  return await axios.get("http://localhost:3000/login?client=RGVtb0NsaWVudA==");
}